// extracted by mini-css-extract-plugin
export default {"cellAnswerTextHeaderColumn":"DV8URmtoh77A1gadoNL5","cellAnswerTextColumn":"khWznnoYmOxytiabCwls"};